import { render, staticRenderFns } from "./ProductVariants.vue?vue&type=template&id=7df87323&"
import script from "./ProductVariants.ts?vue&type=script&lang=ts&"
export * from "./ProductVariants.ts?vue&type=script&lang=ts&"
import style0 from "./ProductVariants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTh,QTd,QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTh,QTd,QBtn,QIcon})
